import styled from 'styled-components';

type MobileSpacerProps = {
  height?: number;
};

// iOS HACK to add spacing to the bottom of the form.
// Needed because the keyboard was covering the form inputs
// Maybe we could trigger this only if the user is on iOS
export const MobileSpacer = styled.div<MobileSpacerProps>`
  ${Styles.mobile} {
    height: ${({ height }: MobileSpacerProps) => (height ? `${height}px` : '50vh')};
  }
`;
